import { useLang } from "@/i18n";
import { PageHero } from "@/components/PageHero";
import { L } from "@/components/L";

export default function NotFound() {
  const { t } = useLang();
  return (
    <PageHero eyebrow="404" lines={[t.notFound.title]} intro={t.notFound.text}>
      <L to="home" className="btn btn-primary mt-10" data-testid="not-found-home-btn">{t.notFound.back}</L>
    </PageHero>
  );
}
